// WHO SEES AN OVERRIDDEN RATE - one wording for every place that asks.
//
// Owner, 2026-10-11: "explain what you mean by visible to them too? does that
// mean members can see it or does that mean on members digests or does that
// mean partners digest ?". It meant the CONTRACTOR (the partner company whose
// hours these are), and three editors each said it differently. So the
// answer lives here, once.
//
// WHAT THE SERVER DOES with `appliesTo` (utils/issueHours.overridePricer):
//   'owner'    - every report, export and digest of THIS account is priced
//                with the rate. The contractor's own emails keep the rate
//                recorded when they submitted.
//   'everyone' - all of that, AND the contractor's own emails (their project
//                digest and their weekly report) show this rate - to those
//                of their people whose roster entry has Cost view on; the
//                rest of them see hours only, as before.
// Neither changes who in YOUR company sees cost: that is the Cost view
// permission, and this setting is not it.
import React from "react";
import { Radio } from "antd";

const T = { muted: "#667085", amber: "#b54708" };

export const AUDIENCE_LABEL = {
  owner: "Your account only",
  everyone: "Also show it to the contractor",
};

export const AUDIENCE_HELP = {
  owner: "Your reports, exports and your team's digests use this rate. The contractor keeps seeing the rate recorded when they submitted.",
  everyone: "Also used in the contractor's own emails (their project digest and weekly report), for those of their people who have Cost view on. Your own team is not affected by this choice.",
};

// Who in your own company sees money is a different setting, said once
// under every choice so the two are not confused.
export const AUDIENCE_FOOTNOTE = "Who in your company sees cost is set by the Cost view permission, not here.";

export function WhoSeesRate({ value, onChange, compact = false }) {
  return (
    <div>
      <Radio.Group value={value} onChange={(e) => onChange(e.target.value)} size={compact ? "small" : undefined}>
        <Radio value="owner">{AUDIENCE_LABEL.owner}</Radio>
        <Radio value="everyone">{AUDIENCE_LABEL.everyone}</Radio>
      </Radio.Group>
      <div style={{ color: value === "everyone" ? T.amber : T.muted, fontSize: compact ? 11.5 : 12, marginTop: 4 }}>
        {AUDIENCE_HELP[value === "everyone" ? "everyone" : "owner"]}
      </div>
      <div style={{ color: T.muted, fontSize: compact ? 11 : 11.5, marginTop: 2 }}>{AUDIENCE_FOOTNOTE}</div>
    </div>
  );
}
